import { stringToBool } from '@/services/stringService';

export default class UserProfile {
    customerId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    zipCode: string;
    glutenFree: number;
    vegetarian: number;
    favoriteStore: number;
    birthdate: string;
    isVisitor: boolean | string; // is '0' or '1';

    constructor(res?: Partial<UserProfile>) {
        this.customerId = res?.customerId ?? '';
        this.firstName = res?.firstName ?? '';
        this.lastName = res?.lastName ?? '';
        this.emailAddress = res?.emailAddress ?? '';

        this.phoneNumber = res?.phoneNumber ?? '';
        this.birthdate = res?.birthdate ?? '';

        // @ts-ignore
        this.zipCode = res?.zipCode ?? res?.customerZip ?? '';
        this.glutenFree = res?.glutenFree ?? 0;
        this.vegetarian = res?.vegetarian ?? 0;
        this.favoriteStore = res?.favoriteStore ?? 0;
        this.isVisitor = res?.isVisitor ? stringToBool(res?.isVisitor) : true;
    }
}
